const survey_rule_placeholder = "1、本次活动只针对心愿盒已注册心愿官<br>2、本次问卷，每位心愿官仅能参加一次<br>3、心愿盒可以根据本次活动的实际情况对活动规则进行变更或调整，相关变更或调整将公布在活动页面上，并与公布后依法生效<br>4、活动期间，如出现不可抗力或情势变更（包括但不限于重大灾害，活动受政府机关指令停止举办或变更，活动受网络影响或系统故障暂定举办的），心愿盒Match box按相关法律法规的规定主张免责<br>5、活动最终解释权归心愿盒所有;"
export default survey_rule_placeholder
